import PropTypes from 'prop-types';
import SearchDiscoveryViewImpl from './search-discovery-view.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * Overlay-based search discovery view. The launcher renders as an icon and opens a dialog listing the
 * main events of the day plus the full sports navigation. Typing replaces the main events with the
 * matching search results while the sports navigation stays in place.
 *
 * @class SearchDiscoveryView
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SearchDiscoveryView` prop types.
 *
 * @property {object} searchResult - Latest search result, as delivered by the search service.
 * @property {object} [mainEvents] - Main-events state connected from the search store.
 * @property {Array<object>} [sports = []] - Sports to list in the navigation section.
 * @property {string} [resetStateToken = ''] - Whenever this token changes the query is cleared and the overlay is dismissed. The component stays agnostic to what the token represents, such as a route, tab or hash, leaving it to the parent to decide.
 * @property {Function} [onSearchClose] - Called whenever the overlay is dismissed.
 * @property {boolean} [initiallyActive = false] - Flag controlling whether the overlay is open on mount.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchDiscoveryView
 */
const propTypes = {
    searchResult: PropTypes.object.isRequired,
    mainEvents: PropTypes.object,
    sports: PropTypes.arrayOf(PropTypes.object),
    resetStateToken: PropTypes.string,
    onSearchClose: PropTypes.func,
    initiallyActive: PropTypes.bool,
};

const defaultProps = {
    sports: [],
    resetStateToken: '',
    onSearchClose: noop,
    initiallyActive: false,
};

export default UIView('SearchDiscoveryView', SearchDiscoveryViewImpl, propTypes, defaultProps);
